import { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/** Text that truncates via the given CSS classes (e.g. `truncate` or
 *  `line-clamp-2`) and, only when actually clipped, reveals the full value in a
 *  hover popover. The DOM structure stays stable so the overflow observer keeps
 *  tracking a single element. */
export function ClampedText({ text, className }: { text: string; className?: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [clipped, setClipped] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () =>
      setClipped(el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span ref={ref} className={className}>
          {text}
        </span>
      </TooltipTrigger>
      {clipped && (
        <TooltipContent side="bottom" className="max-w-xs">
          {text}
        </TooltipContent>
      )}
    </Tooltip>
  );
}
